import React from "react";
import Logo from "../Pic/Logo.png";
import bggif from "../Pic/bggif.gif";

function NavBtn() {
  return (
    <>
      <div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 justify-items-center md:items-center w-fit h-full mx-4 rounded-2xl bg-black mb-4 drop-shadow-lg"
        style={{
          backgroundImage: `url(${bggif})`,
          backgroundRepeat: `no-repeat`,
          backgroundSize: "cover",
          backgroundBlendMode: `screen`,
        }}
      >
        <div>
          <img
            src={Logo}
            className="w-full h-full m-2 p-8 md:m-2 md:scale-125  md:ml-48"
            alt="Logo"
          />
        </div>
        <ul className="list-none uppercase text-center text-white font-bold text-2xl p-4 lg:col-span-3">
          <li className="p-2 hover:scale-2 ">
            <a
              href="https://github.com/psantosh16"
              className="no-underline text-white"
            >
              Github
            </a>
          </li>
          <li className="p-2 hover:scale-2 ">
            <a href="/" className="no-underline text-white">
              Instagram
            </a>
          </li>
          <li className="p-2 hover:scale-2 ">
            <a href="/" className="no-underline text-white">
              LinkedIn
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default NavBtn;
